module.exports = "/_next/static/images/DHH-753775bd825dea58c09e96fb95759963.jpg";